<template>
  <v-row no-gutters>
    <feature-card-basic :layer="layer">
      <template #top v-if="visible">
        <masterplan-streets-widget :lid="+layer.id" :fid="+currentFeatureId" />
      </template>
    </feature-card-basic>
  </v-row>
</template>
<script>
import { get } from 'vuex-pathify';

import FeatureCardBasic from '@/components/FeatureCardBasic';
import MasterplanStreetsWidget from '@/components/MasterplanStreetsWidget';

export default {
  name: 'FeatureCardMasterplanStreets',
  components: { FeatureCardBasic, MasterplanStreetsWidget },
  props: {
    layer: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isAdminEnabled: get('admin/settingsValues@masterplan_2_streets_module_enabled'),
    isSuperAdminEnabled: get('admin/additionalModules@MASTERPLAN_2_STREETS.enabled'),
    permission: get('users/toolsPermissions@MASTERPLAN_2_STREETS.main_value'),
    currentFeatureId() {
      return this.$route.params.fid;
    },
    isNew() {
      return this.currentFeatureId === 'new';
    },
    visible() {
      return this.isSuperAdminEnabled && this.isAdminEnabled && !this.isNew && this.permission;
    },
  },
};
</script>
